import { Dialog, DialogContent, DialogTrigger } from 'components/ui/dialog';

const Steps = ({ step, desc }: { step: string; desc: string }) => {
  return (
    <div className="flex flex-col text-left">
      <p className="text-[12px] text-[#202020] dark:text-gray-300 font-light">{step}</p>
      <p className="text-[17px] font-bold text-[#202020] dark:text-white">{desc}</p>
    </div>
  );
};

const BotInfo = ({ children }: { children: React.ReactNode }) => {
  const stepDetails = [
    {
      step: 'STEP 1',
      desc: 'Search for "BotFather" on Telegram',
    },
    {
      step: 'STEP 2',
      desc: 'type /start',
    },
    {
      step: 'STEP 3',
      desc: 'type /newbot',
    },
    {
      step: 'STEP 4',
      desc: 'Enter the bot name and username',
    },
    {
      step: 'STEP 5',
      desc: 'Receive the bot token',
    },
  ];

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="gap-0">
        <p className="text-[#000A07A0] dark:text-white max-w-[480px] mt-2 text-left text-[14px] font-normal">
          To generate a bot, you&apos;ll need a bot token. Follow the steps
          below to obtain one:
        </p>
        <div className="flex flex-col gap-6 mt-6">
          {stepDetails.map((stepDetail, idx) => {
            return (
              <Steps step={stepDetail.step} desc={stepDetail.desc} key={idx} />
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BotInfo;
